export const getUniqueAdditionalTermsReg = (terms, isReg) => [
  ...new Set(
    terms
      .filter((f) => f && typeof f.path === 'string' && f.path.match(isReg))
      .map((m) => (m.name)),
  ),
].join(',');
